module.exports = __webpack_public_path__ + "static/media/sliderimage1.b43c06b4.jpg";